import { render, staticRenderFns } from "./LocationIndexList.vue?vue&type=template&id=04659b79&scoped=true&"
import script from "./LocationIndexList.vue?vue&type=script&lang=js&"
export * from "./LocationIndexList.vue?vue&type=script&lang=js&"
import style0 from "./LocationIndexList.vue?vue&type=style&index=0&id=04659b79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04659b79",
  null
  
)

export default component.exports